import { Button } from "@mui/material";
import { FaFileExcel } from "react-icons/fa";
import { toast } from "react-toastify";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import * as XLSX from "xlsx";

export const ExportarColeccionExcel = ({ collecion, query }) => {
  
  const getCollection = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/${collecion}?limit=0${query ? query : ""}`);
      console.log(response)
      const data = response.data.docs;

      // Crear un nuevo libro de Excel
      const wb = XLSX.utils.book_new();
      
      // Convertir los datos a una hoja de Excel
      const ws = XLSX.utils.json_to_sheet(data);

      // Ancho de columnas dinámico (min 12, max 40, padding 4)
      try {
        const headers = data && data.length > 0 ? Object.keys(data[0]) : [];
        const cols = headers.map((h) => {
          const maxLen = Math.max(
            String(h).length,
            ...data.map((row) => {
              const val = row?.[h];
              return val == null ? 0 : String(val).length;
            })
          );
          const wch = Math.min(40, Math.max(12, maxLen + 4));
          return { wch };
        });
        if (cols.length) ws['!cols'] = cols;
      } catch {}
      
      // Agregar la hoja al libro
      XLSX.utils.book_append_sheet(wb, ws, "Datos");
      
      // Generar el archivo Excel
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      
      // Crear un blob y descargar el archivo
      const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${collecion}_${new Date().toISOString().split('T')[0]}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success("Archivo Excel exportado exitosamente");
    } catch (error) {
      console.log(error)
      toast.error("Error al exportar a Excel");
    }
  };
  
  return (
    <Button 
      onClick={getCollection} 
      variant="contained" 
      sx={{
        fontSize: "12px",
        fontWeight: "bold",
        fontFamily: "poppins",
        padding: "4px 24px",
        backgroundColor: "#2e7d32",
        transition: "all 0.3s ease",
        textTransform: "none",
        borderRadius: "8px",
        minWidth: "180px",
        maxWidth: "300px",
        '&:hover': {
          backgroundColor: "#1b5e20",
        }
      }}
      endIcon={<FaFileExcel size={14} className="text-white"/>}
    >
      <span style={{ 
        whiteSpace: "nowrap", 
        overflow: "hidden", 
        textOverflow: "ellipsis",
        maxWidth: "300px"
      }}>
        Exportar a Excel
      </span>
    </Button>
  );
};

export const ExportarSeleccionExcel = ( data, name ) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);

  // Ancho de columnas dinámico (min 12, max 40, padding 4)
  try {
    const headers = data && data.length > 0 ? Object.keys(data[0]) : [];
    const cols = headers.map((h) => {
      const maxLen = Math.max(
        String(h).length,
        ...data.map((row) => {
          const val = row?.[h];
          return val == null ? 0 : String(val).length;
        })
      );
      const wch = Math.min(40, Math.max(12, maxLen + 4));
      return { wch };
    });
    if (cols.length) ws['!cols'] = cols;
  } catch {}
  XLSX.utils.book_append_sheet(wb, ws, "Datos");
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${name}_${new Date().toISOString().split('T')[0]}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
